/**
 * prefixProperty
 * @param _cssName {string}
 * @return {string} css name
 */
module.exports = (() => {
  return {
    getPrefixProperty: (_property) => {
      const decs_ = getComputedStyle(document.head, '');

      const prefixs_ = [ '-webkit-', '-moz-', '-ms-', '-o-' ];

      let property_ = _property;

      if(!decs_[_property]) {
        _.forEach(prefixs_, (_prefix) => {
          const p_ = _prefix + _property;
          if(decs_[p_]) {
            property_ = p_;
            return false;
          }
        });
      }

      return property_;
    },
  }
})();



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/module/prefix-property.js
 **/